<template>
  <nav class="tabs">
    <ul>
      <li v-for="(menuItem, index) in menu" v-bind:key="index">
        <router-link v-bind:to="menuItem.link">{{ menuItem.name }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    menu: Array
  },
  name: 'TabNav',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

li {
  display: inline-block;
  padding: 0;
  margin: 0 10px;
}

nav.tabs {
  position: absolute;
  bottom: 0;

  a {
    display: inline-block;
    @extend %type-epsilon;
    height: 40px;
    padding: 0 5px;
    line-height: 33px;
    color: $text-inactive;
    text-decoration: none;

    &:hover,
    &.router-link-exact-active {
      color: $secondary;
      border-bottom: 5px solid $secondary;
    }
  }
}
</style>
